var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52617",
    "data-name": "Group 52617",
    transform: "translate(-1093 -573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52537",
    "data-name": "Group 52537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M0,10.057V23.943C0,29.959,3.869,34,9.631,34H24.37C30.131,34,34,29.959,34,23.943V10.057C34,4.043,30.129,0,24.368,0H9.631C3.869,0,0,4.043,0,10.057",
    transform: "translate(1093 607) rotate(-90)",
    fill: "#93a750",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_4_",
    "data-name": "svgexport-7 (4)",
    transform: "translate(1098.232 578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52538",
    "data-name": "Group 52538",
    transform: "translate(2.768)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_492",
    "data-name": "Ellipse 492",
    cx: 1.373,
    cy: 1.373,
    r: 1.373,
    transform: "translate(15.982 3.66)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_493",
    "data-name": "Ellipse 493",
    cx: 1.373,
    cy: 1.373,
    r: 1.373,
    transform: "translate(12.321 0.915)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_494",
    "data-name": "Ellipse 494",
    cx: 1.373,
    cy: 1.373,
    r: 1.373,
    transform: "translate(8.661)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_495",
    "data-name": "Ellipse 495",
    cx: 1.373,
    cy: 1.373,
    r: 1.373,
    transform: "translate(5.001 1.83)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90981",
    "data-name": "Path 90981",
    d: "M18.749,5.16v5.948a.458.458,0,1,1-.915,0V2.415H15.089v7.778a.458.458,0,1,1-.915,0V1.5H11.428v8.693a.458.458,0,1,1-.915,0V3.33H7.768V14.769L5.915,12.233a1.786,1.786,0,0,0-2.406-.645,1.733,1.733,0,0,0-.435,2.421s2.989,4.523,4.263,6.46,3.337,3.451,7.2,3.451c6.389,0,6.961-4.934,6.961-6.406V5.16Z",
    transform: "translate(-2.768 -0.127)",
    fill: "#93a750"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/HandIcon.82e9e529dbe3b9d6ac93c3288260f39d.svg";
export { ForwardRef as ReactComponent };